
import React from "react";
import Header from "./shared/Header";
import Footer from "./shared/Footer";
import { i18nManager } from "../i18n";
import Contact from "./shared/Contact";
import Breadcrumb from "./shared/Breadcrumb";
import * as ReactRouterDom from "react-router-dom";
import { CacheManager, Debugger, Utils } from "../utils";
import LoadingGif from "../assets/images/loading_circle.gif";
import { ApiResponseData, FaqService, IFaq, IPlatform, ISupportArticle, ISupportCategory, ISupportRequest, SanitizedResponse, SupportArticleService, SupportCategoryService, SupportRequestService } from "../services";

function SearchResult() {
    const faqService = FaqService.getInstance();
    const { platform } = ReactRouterDom.useParams();
    const labels = i18nManager.Labels.search_and_404;
    const activePlatform = CacheManager.getPlatform(platform);
    const supportRequestService = SupportRequestService.getInstance();
    const [sectionCount, setSectionCount] = React.useState<number>(0);
    const [faqs, setFaqs] = React.useState<ApiResponseData<IFaq>>({});
    const supportArticleService = SupportArticleService.getInstance();
    const [searchParams, _] = ReactRouterDom.useSearchParams(window.location.search);
    const [supportRequests, setSupportRequests] = React.useState<ApiResponseData<ISupportRequest>>({});
    const [supportArticles, setSupportArticles] = React.useState<ApiResponseData<ISupportArticle>>({});
    const searchQuery = searchParams.get("q") ?? "";

    React.useEffect(() => {
        if (!activePlatform) return;
        setSectionCount(0);
        (async () => {
            let faqsResult;
            let supportArticlesResult;
            let supportRequestsResult;
            try {
                faqsResult = (await faqService.queryFaqs({ sort: "id,ASC", title: searchQuery, "platform.external_id": activePlatform?.external_id }))?.sanitized;
                Debugger.log("SearchResult:useEffect:queryFaqs", faqsResult);
                setFaqs(faqsResult);
            } catch (error: any) {
                Utils.reportError(error);
            }
            try {
                supportArticlesResult = (await supportArticleService.querySupportArticles({ sort: "helpful,DESC", content: searchQuery, "platform.external_id": activePlatform?.external_id }))?.sanitized;
                Debugger.log("SearchResult:useEffect:querySupportArticles", supportArticlesResult);
                setSupportArticles(supportArticlesResult);
            } catch (error: any) {
                Utils.reportError(error);
            }
            try {
                supportRequestsResult = (await supportRequestService.querySupportRequests({ title: searchQuery, "platform.external_id": activePlatform?.external_id }))?.sanitized;
                Debugger.log("SearchResult:useEffect:querySupportRequests", supportRequestsResult);
                setSupportRequests(supportRequestsResult);
            } catch (error: any) {
                Utils.reportError(error);
            }
            setSectionCount(3);
        })();
    }, [searchParams]);

    return (<div className="support">
        <Header title={labels.search_result} searching />
        <Breadcrumb breadCrumbs={[{ label: labels.search_result, location: window.location.href }]} />
        <div className="search-result">
            {sectionCount === 0 ? (<img alt={`Rivtn Support Search: ${searchQuery}`} src={LoadingGif} />) : null}
            {(sectionCount !== 0) && !(faqs.total_elements || supportArticles.total_elements || supportRequests.total_elements) ? (<div className="no-result">
                <span className="title">{labels.nothing_found}</span>
                <span className="desc">{labels.sorry_try_search_again}</span>
            </div>) : null}
            {sectionCount > 0 && supportRequests.total_elements ? (<div className="result">
                <span>{labels.tickets_that_matches}</span>
                <div>
                    {supportRequests.content?.map((e) => (<a key={e.external_id} href={`/${platform}/support/ticket/${e.external_id}`} dangerouslySetInnerHTML={{ __html: highlightMatchingLocation(e.title) }}></a>))}
                </div>
            </div>) : null}
            {sectionCount > 0 && faqs.total_elements ? (<div className="result">
                <span>{labels.faqs_that_matches}</span>
                <div>
                    {faqs.content?.map((e) => (<a key={e.external_id} href={`/${platform}/faqs#${e.external_id}`} dangerouslySetInnerHTML={{ __html: highlightMatchingLocation(e.title) }}></a>))}
                </div>
            </div>) : null}
            {sectionCount > 0 && supportArticles.total_elements ? (<div className="result">
                <span>{labels.articles_that_matches}</span>
                <div>
                    {supportArticles.content?.map((e) => (<a key={e.external_id} href={`/${platform}/article/${e.external_id}`}>
                        <b>{e.title}: </b>
                        <span dangerouslySetInnerHTML={{ __html: highlightMatchingLocation(e.content) }} />
                    </a>))}
                </div>
            </div>) : null}
        </div>
        <Contact />
        <Footer />
    </div>);

    function highlightMatchingLocation(value: string) {
        let newValue = "";
        const splits = value.split(searchQuery);
        for (let index = 0; index < splits.length; index++) {
            newValue += splits[index];
            if (index < (splits.length - 1)) newValue += `<span class="highlight">${searchQuery}</span>`;
        }
        const firstIndexOfValue = newValue.indexOf(searchQuery);
        return newValue.substring(firstIndexOfValue - 200, firstIndexOfValue + 200) + (newValue.length > 600 ? "..." : "");
    }

}

export default SearchResult;
